import * as d3 from "d3";
import { PQ4castDataType } from "../models/metMap/pQ4castDataType";
import AlarmLogic from "../logic/alarmLogic";
import { AlarmLevel } from "../models/metMap/forecastResult";
export var ColorScale;
(function (ColorScale) {
    ColorScale[ColorScale["Matt"] = 0] = "Matt";
    ColorScale[ColorScale["Loud"] = 1] = "Loud";
})(ColorScale || (ColorScale = {}));
export class ColorStyling {
    static interpolatedAlarmColor(alarmRatio, scale = ColorScale.Matt) {
        alarmRatio = Math.max(0, Math.min(1, alarmRatio));
        if (isNaN(alarmRatio)) {
            const grey = d3.hsl("grey").brighter();
            grey.opacity = .6;
            return grey;
        }
        const colorWorst = ColorStyling.alarmColor(AlarmLevel.AboveMax, scale);
        const colorWarn = ColorStyling.alarmColor(AlarmLevel.Warning, scale);
        const colorBest = ColorStyling.alarmColor(AlarmLevel.OK, scale);
        const warnRatio = AlarmLogic.AlarmRatio_Warning;
        if (alarmRatio > warnRatio) {
            return d3.hsl(d3.interpolateHsl(colorWarn, colorWorst)((alarmRatio - warnRatio) / (1 - warnRatio)));
        }
        else {
            return d3.hsl(d3.interpolateHsl(colorBest, colorWarn)(alarmRatio / warnRatio));
        }
    }
    static alarmColor(alarmLevel, scale) {
        if (alarmLevel === AlarmLevel.NoValue) {
            const grey = d3.hsl("grey").brighter();
            grey.opacity = .6;
            return grey;
        }
        if (scale === ColorScale.Loud) {
            switch (alarmLevel) {
                case AlarmLevel.OK: return d3.hsl("green");
                case AlarmLevel.Warning: return d3.hsl("orange");
                case AlarmLevel.Alarm: return d3.hsl("red");
                case AlarmLevel.AboveMax: return d3.hsl("darkred");
            }
        }
        else {
            switch (alarmLevel) {
                case AlarmLevel.OK: return d3.hsl(120, .4, .6);
                case AlarmLevel.Warning: return d3.hsl(50, .4, .6);
                case AlarmLevel.Alarm: return d3.hsl(25, .4, .6);
                case AlarmLevel.AboveMax: return d3.hsl(0, .4, .6);
            }
        }
        //return d3.hsl("grey");
    }
    static channelColor(dataType, index) {
        const paletteDefault = ["#205C6F", "#765388", "#0000A6", "#FFDBE5", "#7A4900", "#FF4A46", "#63FFAC", "#008941", "#006FA6", "#A30059",
            "#B79762", "#004D43", "#8FB0FF", "#997D87", "#5A0007", "#809693", "#FEFFE6", "#1B4400",
            "#4FC601", "#3B5DFF", "#4A3B53", "#FF2F80", "#61615A", "#BA0900", "#6B7900", "#00C2A0",
            "#FFAA92", "#FF90C9", "#B903AA", "#D16100", "#DDEFFF", "#000035", "#7B4F4B", "#A1C299",
            "#300018", "#0AA6D8", "#013349", "#00846F", "#372101", "#FFB500", "#C2FFED", "#A079BF",
            "#CC0744", "#C0B9B2", "#C2FF99", "#001E09", "#00489C", "#6F0062", "#0CBD66", "#EEC3FF",
            "#456D75", "#B77B68", "#7A87A1", "#788D66", "#885578", "#FAD09F", "#FF8A9A", "#D157A0", "#BEC459", "#456648", "#0086ED", "#886F4C"], paletteU = ["#B24E2E", "#32773F", "#205C6F", "#765388"], paletteI = ["#D06D16", "#70B922", "#1B4850", "#C34B87", "#369DA1", "#392C13", "#4C7F24", "#C4844F", "#52FAD2"], palette = (dataType === PQ4castDataType.Voltage || dataType === PQ4castDataType.ThdU) ?
            paletteU : paletteDefault;
        return d3.hsl(palette[index]);
    }
    static hslModify(color, sFactor, lFactor, oFactor) {
        return d3.hsl(color.h, sFactor * color.s, lFactor * color.l, oFactor * color.opacity);
    }
    static getHullColors() {
        const colors = ["green", "grey", "blue", "red", "yellow",
            "cyan", "maroon", "teal", "sandybrown", "lime",
            "orange", "brown", "indigo", "darkred", "purple", "darkgreen"];
        return colors.map(c => {
            const color = d3.hsl(c);
            color.s = .4 * color.s;
            return color;
        });
    }
}
//Dubletter med powmonBoard.css
ColorStyling.activePower = "#49b7c1";
ColorStyling.reactivePower = "#284677";
ColorStyling.consumptionPower = "#387e9c";
ColorStyling.activePowerProduction = "#96d149";
ColorStyling.reactivePowerProduction = "#3FBF18";
ColorStyling.productionPower = "#70e31e";
